module.exports = __webpack_public_path__ + "static/media/node.0aa8ef8b.svg";